import React from 'react';

/* */
class TermsAndConditions extends React.Component {
  /* */
  constructor(props) {
    super(props);
    document.title = "Conditions générales d'utilisation";
  }

  /* */
  render() {
    return (
      <div className='page'>
        <h1>Conditions générales d'utilisation</h1>
        <h2>I. Introduction et consentement</h2>
        <p>
          Bienvenue sur l’application Prima.Golf et sur le site internet www.prima.golf (l'application et le site
          internet seront nommés le "Site"). Lorsque vous utilisez le site, vous acceptez, sans réserve ni restriction,
          de respecter les présentes conditions (‘’Conditions’’). Si vous n’acceptez pas les présentes conditions,
          veuillez ne pas utiliser le présent Site.
        </p>
        <p>
          Veuillez noter que le Site peut contenir des liens vers d’autres sites web, opérés par de tierces parties, et
          sont sujets à leurs propres termes et conditions.
        </p>
        <h2>II. Confidentialité</h2>
        <p>
          Pour connaître la politique de Prima.Golf en matière de collecte, d’utilisation et de communication de
          renseignements sur les utilisateurs, veuillez consulter notre politique de vie privée.
        </p>
        <h2>III. Inscription</h2>
        <p>
          L’utilisation de certains services et fonctions offertes sur le Site, exige une inscription. Si vous décidez
          de vous inscrire ou de vous abonner à ces services ou fonctions, vous acceptez de fournir des renseignements
          exacts et à jour à votre sujet comme l’exige le processus d’inscription ou d’abonnement pertinent, et de vous
          assurer de leur exactitude en effectuant les mises à jour nécessaires dès que possible. Vous acceptez :
        </p>
        <ul>
          <li>
            d’assurer la confidentialité de tous les mots de passe ou autres éléments d’identification de compte que
            vous aurez choisis ou qui vous seront attribués au moment d’une inscription ou d’un abonnement
          </li>
          <li>
            d’assumer la responsabilité à l’égard de toutes les activités reliées à l’utilisation de ces mots de passe
            ou de ces comptes. Prima.Golf ne peut aucunement être tenue responsable, directement ou indirectement, des
            pertes ou dommages de quelque nature que ce soit résultant du défaut de vous conformer à la présente
            disposition, ou liés à un tel défaut. Si Prima.Golf a des raisons de croire que l’information communiquée
            dans le cadre de l’inscription n’est pas pertinente, Prima.Golf se réserve le droit de supprimer le compte
            en question.
          </li>
        </ul>
        <h2>IV. Transactions</h2>
        <p>
          Dans le cas où vous utiliserez les différentes fonctionnalités du Site (réservation de départs, abonnement,
          inscription à une compétition, …) veuillez vous référer à la politique d’utilisation et à la politique
          d’annulation.
        </p>
        <h2>V. Sécurité de votre compte</h2>
        <p>
          Vous êtes entièrement responsable du maintien de la confidentialité de votre mot de passe. De plus, vous
          acceptez de prévenir Prima.Golf de toute utilisation non autorisée de votre mot de passe ou de votre compte en
          le communiquant à l’adresse tech@primagolf.fr. Afin de supprimer votre compte, vous pouvez envoyer un courriel
          à tech@primagolf.fr. Précisez dans votre courriel la nature de votre demande. Prima.Golf se réserve le droit
          de divulguer l’information de votre compte, incluant l’information reliée à votre carte de crédit, dans des
          cas qui relèvent de la loi et la sécurité du Site et de ses utilisateurs. Ces cas inclus toutes questions de
          fraude et réduction de risque de crédit.
        </p>
        <h2>VI. Eligibilité</h2>
        <p>
          Ce Site est pour les utilisateurs de 16 ans et plus. Toute inscription ou utilisation du site par un mineur de
          moins de 16 ans n’est pas autorisée et en violation des présents termes et conditions. En utilisant ce Site,
          vous reconnaissez être âgé de 16 ans et plus et vous vous engagez à respecter les termes et conditions de
          cette politique.
        </p>
        <h2>VII. Conduite des utilisateurs</h2>
        <p>
          Quand vous utilisez ce Site, vous acceptez de respecter toutes les lois applicables ainsi que les présentes
          conditions. Vous reconnaissez que Prima.Golf peut enquêter sur toute violation de la loi et collaborer avec
          les autorités chargées de l’application des lois dans le cadre de poursuite contre un utilisateur. De plus,
          vous vous engagez à ne pas faire ce qui suit :
        </p>
        <p>
          Afficher, transmettre ou distribuer tout renseignement, matériel ou contenu (y compris un logiciel) renfermant
          un virus, un robot d’annulation de messages, un cheval de Troie, un ver ou tout autre élément nocif ou
          perturbateur, ou établir un lien vers ce type de renseignement, matériel ou contenu;{' '}
        </p>
        <p>
          Afficher, transmettre ou distribuer des renseignements ou du contenu, ou établir un lien vers du matériel, des
          renseignements ou du contenu qui visent, préconisent ou encourageant une conduite qui pourrait constituer une
          infraction criminelle ou engager une responsabilité civile, ou utiliser autrement un site ou un service de
          Prima.Golf de façon illégale ou dans le but de restreindre ou d’entraver l’utilisation par une autre personne
          de ce Site;{' '}
        </p>
        <p>Créer ou utiliser une fausse identité; </p>
        <p>
          Ajouter des liens profonds à toute portion du présent Site, quel qu’en soit le but, sans notre autorisation
          expresse écrite;{' '}
        </p>
        <p>
          Bloquer toute partie du site Web, en créer une image miroir ou l’incorporer d’une autre façon à un autre site
          Web sans notre autorisation écrite préalable;
        </p>
        <p>Essayez d’avoir accès aux parties du site qui ne sont pas accessibles au grand public.</p>
        <h2>VIII. Contenu lié au site</h2>
        <p>
          Veuillez noter que le Site peut contenir des liens vers d’autres sites Web. Prima.Golf fournit ces liens pour
          votre commodité uniquement et leur inclusion ne constitue pas une recommandation de Prima.Golf. Prima.Golf
          n’exerce pas de contrôle sur les sites liés. Quand vous visitez un site Web lié, vous le faites à vos risques
          et il vous appartient de prendre toutes les mesures de protection appropriées contre les virus et autres
          éléments destructeurs. Prima.Golf n’assume aucune responsabilité à l’égard du contenu de ces sites liés ou de
          toute autre page Web ne faisant pas partie du Site et sur laquelle elle n’exerce aucun contrôle. Sauf
          indication contraire énoncée expressément, Prima.Golf ne faut aucune représentation ni recommandation et
          n’offre aucune garantie à l’égard des sites liés ni des renseignements, produits ou services qui y figurent.
          En conséquence, vous reconnaissez que Prima.Golf n’assume aucune responsabilité pour ce qui est de
          l’exactitude, de la pertinence, de la conformité au droit d’auteur, de la légalité ou de la convenance des
          éléments qui figurent sur les sites auxquels renvoie le Site Prima.Golf.
        </p>
        <h2>IX. Services mobiles</h2>
        <p>
          Le Site est également accessible à partir d’un appareil mobile. Il n’y a aucun frais d’utilisation pour ce
          service mais les frais normaux demandés par votre opérateur mobile s’appliquent. Cette politique s’applique
          également à l’accès du Site à partir d’un appareil mobile. Tout ce que vous remplissez sur le Site à partir
          d’un appareil mobile sera également stocké sur les serveurs de Prima.Golf.
        </p>
        <h2>X. Propriété intellectuelle</h2>
        <p>
          La présente disposition s’applique à tout matériel, renseignement et contenu (le ‘’Contenu’’) offert sur le
          Site Prima.Golf, y compris tout logiciel, design, images, texte, data, photos, illustrations, clips audio,
          clips vidéo, graphisme, logos, icônes et marques de commerce. Le Contenu est protégé par les lois et les
          traités français sur le droit d’auteur. Prima.Golf vous concède une licence limitée, non exclusive et non
          transférable qui vous permet d’utiliser et d’afficher sur votre ordinateur ou un autre dispositif d’accès
          électronique, le contenu et les services pour votre usage personnel uniquement et non à des fins commerciales,
          pourvu que vous acceptiez de ne pas le modifier et de conserver tous les avis relatifs aux droits d’auteur et
          aux droits de propriété. Sauf indication contraire dans les présentes, vous vous engagez à ne pas reproduire,
          retransmettre, distribuer, vendre, publier, communiquer, diffuser ou autrement rendre accessible aucune partie
          du contenu obtenue par le biais de ce Site, ni d’en faire des œuvres dérivées, notamment par la mise en cache,
          la mise en forme ou un autre moyen semblable, sans avoir préalablement obtenu le consentement écrit du droit
          d’auteur du contenu en question.
        </p>
        <h2>XII. Déni de responsabilité</h2>
        <p>Vous comprenez et acceptez expressément ce qui suit :</p>
        <p>
          Le site et les services de Prima.Golf sont offerts ‘’tels quels’’ et en fonction de leur disponibilité, et
          Prima.Golf ne donne aucune garantie et ne fait aucune déclaration d’aucune sorte, expresse ou implicite,
          notamment de garantie implicite de qualité marchande, d’adaptation à un usage particulier et d’absence de
          contrefaçon, et Prima.Golf rejette expressément de telles garanties
        </p>
        <p>
          Prima.Golf ne donne aucune garantie que le site et les services de Prima.Golf, y compris le contenu, les
          renseignements, seront accessibles sans interruption, en temps utile, en toute sécurité et sans erreur, ni que
          de tels service ou les résultats obtenus par suite de leur utilisation répondront à vos exigences ou vos
          attentes.
        </p>
        <p>
          Les renseignement, logiciels et services publiés sur le présent site peuvent contenir des inexactitudes ou des
          erreurs y compris des erreurs de prix. Prima.Golf n’assume aucune responsabilité en cas d’erreur ou
          d’inexactitude relation à l’information concernant un golf ou la description de celui ci (notamment les prix,
          photographies, commodités offertes par le club de golf et les descriptions générales). de plus, Prima.Golf se
          réserve expressément le droit de corriger toute erreur de prix sur notre site web. Dans un tel cas, nous vous
          offrirons le choix de maintenir votre achat  en cours au prix corrigé ou, si vous le souhaitez, nous
          annulerons votre achat sans pénalité.
        </p>
        <p>
          Prima.Golf ne pourra être tenu responsable envers les utilisateurs du site et de ses services pour toute perte
          ou dommage indirect, accessoire ou spécial, toute perte de profit, perte d’occasion ou de revenu ou autre
          réclamations de rémunération quelconques découlant directement ou indirectement des présentes conditions
          générales ou en rapport avec celles-ci, incluant tout achat ou confirmation d’achat, incluant toute omission
          ou tout retard à remplir toute obligation des présentes. La responsabilité de Prima.Golf relativement à toutes
          réclamations découlant de l’exécution ou de la non-exécution des obligations reliés à tout service provenant
          du site ne saura excéder le prix d’achat payé à Prima.golf. un tel montant s’avérera le seul recours de
          l’acheteur ainsi que la seule responsabilité de Prima.Golf à ces égards.
        </p>
        <p>
          Prima.Golf ne pourra être tenu responsable pour la non-exécution des obligations reliées à tout service
          provenant du Site si cette non-exécution est causé par un événement hors de son contrôle, incluant mais
          n’étant pas limité à, une panne Internet, une panne des réseaux de communication, un feu, une inondation ou
          une guerre.
        </p>
        <h2>Contactez Prima.Golf</h2>
        <p>
          N’hésitez pas à partager tout commentaire ou inquiétude. Si vous avez des questions au sujet de cette
          politique sur la vie privée, contactez :
        </p>
        <p>
          <strong>Prima.Golf</strong>
          <br />
          16 Place du Martroi
          <br />
          45000 Orléans
        </p>
        <p>Ou par courriel : tech@primagolf.fr</p>
        <br />
        <hr />
        <br />
        <h1>
          CONDITIONS GENERALES D&#39;UTILISATION ET DE RESERVATION DES SERVICES (CGR)
          <br />
          Site Internet Prima.golf
        </h1>
        <h2>ARTICLE 1 : DEFINITIONS</h2>
        <p>
          CGR : Conditions G&eacute;n&eacute;rales de R&eacute;servation et d&rsquo;Utilisation du Site
          <br />
          Client : toute personne physique ou personne morale habilit&eacute;e qui r&eacute;serve sur le Site un
          parcours de golf ou une prestation aff&eacute;rente au golf.
          <br />
          Golf: Entit&eacute; exploitant un parcours de Golf, et qui permet aux Clients de r&eacute;server ses parcours,
          ses services via le Site
          <br />
          Le Service Payant : service de r&eacute;servation en temps r&eacute;el de parcours de golf disponibles sur le
          Site
          <br />
          Les Services : ensemble de services disponibles sur le site apr&egrave;s ouverture d&rsquo;un compte
          Utilisateur
          <br />
          Site : le site www.prima.golf , exploit&eacute; par la soci&eacute;t&eacute; APS MANAGEMENT- PRIMA.
          <br />
          Utilisateur: toute personne physique qui se rend sur le Site et cr&eacute;e un compte utilisateur
        </p>
        <h2>ARTICLE 2 : PRESENTATION DU SITE PRIMA.GOLF ET DU SERVICE</h2>
        <h3>2.1 IDENTIFICATION DU PRESTATAIRE ET CONTACT</h3>
        <p>
          Le site www.prima.golf est &eacute;dit&eacute; par APS MANAGEMENT-PRIMA, une soci&eacute;t&eacute; &agrave;
          responsabilit&eacute; limit&eacute;e au capital de 76930 euros, dont le si&egrave;ge social est situ&eacute;
          au 16 Place du Martroi 45000 ORLEANS, immatricul&eacute;e au registre du commerce et des
          soci&eacute;t&eacute;s de Orl&eacute;ans sous le num&eacute;ro 51480776700033, et dont le num&eacute;ro de TVA
          intracommunautaire est&nbsp;FR80514807767.
          <br />
          Le Responsable de publication est Monsieur Olivier BEGUE.
          <br />
          Le service client est accessible de 9h &agrave; 19h au num&eacute;ro suivant : 02 38 42 18 23
          <br />
          L&rsquo;adresse &eacute;lectronique du service client est : contact@primagolf.fr
          <br />
          L&rsquo;adresse &eacute;lectronique permettant de signaler un abus : contact@primagolf.fr
          <br />
          Le site est h&eacute;berg&eacute; par APS MANAGEMENT.
        </p>
        <h3>2.2 PRESENTATION DU SERVICE</h3>
        <p>
          Le Site permet aux golfs de mettre &agrave; disposition des golfeurs un ensemble de services&nbsp;:
          r&eacute;servation de parcours, de voiturettes, &hellip;, inscription aux comp&eacute;titions et aux
          &eacute;v&eacute;nements, abonnement/cotisations, recharge de compte practice, &hellip; <br />
          Les Services et le Service Payant n&eacute;cessitent la cr&eacute;ation d&rsquo;un compte utilisateur, qui
          requiert l&rsquo;acceptation des pr&eacute;sentes conditions g&eacute;n&eacute;rales d&rsquo;utilisation et de
          r&eacute;servation.
          <br />
          Le Site peut &ecirc;tre amen&eacute; &agrave; diffuser &eacute;galement des publicit&eacute;s et &agrave;
          mettre en avant des offres promotionnelles.
        </p>
        <h2>ARTICLE 3 : CREATION DE COMPTE ET FORMATION DU CONTRAT</h2>
        <h3>3.1. INFORMATIONS REQUISES</h3>
        <p>
          L&rsquo;Utilisateur d&eacute;clare ne pas &ecirc;tre frapp&eacute; d&rsquo;une incapacit&eacute;, et/ou
          b&eacute;n&eacute;ficier d&rsquo;une autorisation parentale s&rsquo;il est mineur, ou pour une personne
          morale, b&eacute;n&eacute;ficier des pouvoirs n&eacute;cessaires, en vue de la cr&eacute;ation d&rsquo;un
          compte utilisateur, et/ou de la souscription au Service Payant. Le Client dispose d&rsquo;un compte bancaire
          associ&eacute; &agrave; une carte bancaire.
          <br />
          L&rsquo;Utilisateur (non membre ou non abonn&eacute;) cr&eacute;e un compte en renseignant le formulaire en
          ligne qui comprend les champs obligatoires suivants : nom, pr&eacute;nom, adresse &eacute;lectronique et mot
          de passe.
          <br />
          L&rsquo;Utilisateur s&rsquo;engage &agrave; fournir des informations exactes, compl&egrave;tes et &agrave;
          jour. Il reconna&icirc;t que son adresse &eacute;lectronique et son mot de passe sont des
          &eacute;l&eacute;ments essentiels en vue de l&rsquo;ex&eacute;cution du Service Payant et qu&rsquo;en cas
          d&rsquo;adresse erron&eacute;e ou incompl&egrave;te, il s&rsquo;expose &agrave; ne pas pouvoir
          b&eacute;n&eacute;ficier des services, sans droit &agrave; remboursement. Il s&rsquo;engage par
          cons&eacute;quent &agrave; informer APS MANAGEMENT- PRIMA ou son golf de rattachement de tout changement
          d&rsquo;adresse &eacute;lectronique.
        </p>
        <p>
          Le golfeur dispose&nbsp;:
          <br />- des caract&eacute;ristiques essentielles des diff&eacute;rents services, <br />- le prix en Euros, TVA
          comprise au taux en vigueur au jour de la commande, le pourcentage de r&eacute;duction le cas
          &eacute;ch&eacute;ant,
          <br />- les modalit&eacute;s de paiement,
          <br />
          Les offres de services et prix associ&eacute;s restent valables tant qu&#39;ils sont visibles en ligne sur le
          Site et jusqu&#39;&agrave; &eacute;puisement. Les Prix varient selon les saisons, les jours de semaine, de
          week-end ou jours f&eacute;ri&eacute;s, ainsi que selon les horaires. Par nature, le Service de
          r&eacute;servation en temps r&eacute;el fait varier les offres en temps r&eacute;el et le cas
          &eacute;ch&eacute;ant les prix correspondants, en fonction notamment du laps de temps restant avant la date de
          parcours ou en fonction du taux d&rsquo;occupation.
        </p>
        <h3>3.2. ACCEPTATION DES CGR ET CONTRAT</h3>
        <p>
          La validation du formulaire de cr&eacute;ation de compte requiert l&rsquo;acceptation des pr&eacute;sentes
          CGR.
          <br />
          La cr&eacute;ation de compte utilisateur r&eacute;sulte de la validation du bouton &laquo; s&rsquo;inscrire
          &raquo; apr&egrave;s avoir renseign&eacute; le formulaire, qui comprend la mention &laquo; en validant ce
          formulaire, j&rsquo;accepte les conditions g&eacute;n&eacute;rales d&rsquo;utilisation et de
          r&eacute;servation &raquo;, lesdites CGR &eacute;tant cliquables et permettant la consultation du texte dans
          son int&eacute;gralit&eacute;.
          <br />
          L&rsquo;Utilisateur reconnait avoir lu les CGR attentivement et en accepter express&eacute;ment le contenu. Il
          est recommand&eacute; au Client d&rsquo;imprimer les CGR ou de les enregistrer sur son ordinateur afin de
          pouvoir s&rsquo;y r&eacute;f&eacute;rer ult&eacute;rieurement.
          <br />
          Les CGR applicables sont celles disponibles en ligne &agrave; l&rsquo;adresse
          https://prima.golf/terms-conditions &agrave; la date de souscription au Service, et pourront &ecirc;tre
          modifi&eacute;es ult&eacute;rieurement.
          <br />
          La r&eacute;servation du Service Payant est form&eacute; par (i) la cr&eacute;ation du compte Utilisateur (ii)
          la validation du formulaire r&eacute;capitulatif de commande (iii) la validation des informations de paiement
          par V&eacute;rifone. Est &eacute;galement applicable au contrat (iv) le r&egrave;glement int&eacute;rieur du
          Golf disponible sur site du golf.
          <br />
          Un mail de confirmation de commande est promptement adress&eacute; par mail au Client &agrave; l&rsquo;adresse
          &eacute;lectronique qu&rsquo;il aura renseign&eacute;e.
          <br />
          Aucune r&eacute;servation de services ne pourra donc &ecirc;tre prise en compte par APS MANAGEMENT &ndash;
          PRIMA par t&eacute;l&eacute;phone, courrier postal, courrier &eacute;lectronique ou t&eacute;l&eacute;copie.
        </p>
        <h3>3.3. PAIEMENT</h3>
        <p>
          Le Client s&rsquo;engage &agrave; remplir les champs relatifs au mode de paiement avec ses donn&eacute;es
          bancaires personnelles, &agrave; jour et compl&egrave;tes. Le paiement du Service requiert que le Client
          dispose d&rsquo;une carte bleue, Mastercard, visa.
          <br />
          Les donn&eacute;es transmises sont crypt&eacute;es et directement transmises &agrave;
          l&rsquo;&eacute;tablissement de paiement V&eacute;rifone, sans transiter par APS MANAGEMENT - PRIMA.
          V&eacute;rifone proc&egrave;de au traitement du paiement et d&eacute;bite le compte du Client.
          <br />
          Si le paiement venait &agrave; &ecirc;tre r&eacute;voqu&eacute; pour quelque cause que ce soit, la
          r&eacute;servation du service en serait imm&eacute;diatement annul&eacute;e.
          <br />
          Une facture peut-&ecirc;tre &eacute;mise par le Golf, au moment de l&rsquo;ex&eacute;cution de la prestation.
        </p>
        <h3>3.4 DROIT DE RETRACTATION</h3>
        <p>
          Le droit de r&eacute;tractation n&rsquo;est pas applicable sur le Service, en vertu de l&rsquo;article L
          121-20-4 du code de la consommation qui dispose : &laquo;les dispositions des articles L. 121-20 et L.
          121-20-1 ne sont pas applicables aux contrats ayant pour objet la prestation de services de loisirs qui
          doivent &ecirc;tre fournis &agrave; une date ou selon une p&eacute;riodicit&eacute;
          d&eacute;termin&eacute;e&raquo;.
        </p>
        <h3>3.5. CONVENTION DE PREUVE</h3>
        <p>
          Les parties reconnaissent et acceptent express&eacute;ment que les donn&eacute;es conserv&eacute;es par APS
          MANAGEMENT-PRIMA et par le Golf dans leur syst&egrave;me informatique au titre des commandes, du paiement, de
          la facture, de l&rsquo;ex&eacute;cution du service, ou de la diffusion des contenus mis en ligne par le Client
          feront foi entre les parties, sauf preuve contraire constat&eacute;e par huissier.
        </p>
        <h2>ARTICLE 4. EXECUTION DU CONTRAT</h2>
        <h3>4.1. EXECUTION PAR LE GOLF</h3>
        <p>
          Le Contrat de service propos&eacute; par APS MANAGEMENT - PRIMA est conclu pour le compte du Golf exploitant
          le parcours et les services choisi par le Client. Le Golf est donc exclusivement responsable sur place des
          conditions d&rsquo;ex&eacute;cution du service au b&eacute;n&eacute;fice du Client et de son &eacute;ventuel
          remboursement. APS MANAGEMENT-PRIMA ne pourra proc&eacute;der &agrave; aucun remboursement de la
          r&eacute;servation.
          <br />
          En cas d&rsquo;op&eacute;ration d&rsquo;entretien du parcours et des services associ&eacute;s, APS MANAGEMENT
          - PRIMA ne saurait &ecirc;tre responsable de la g&ecirc;ne ou modification de parcours/ de service
          occasionn&eacute;e au Client. Les Conditions g&eacute;n&eacute;rales du Golf pourront pr&eacute;voir des
          dispositions sp&eacute;cifiques &agrave; cet &eacute;gard dont le Client pourra r&eacute;clamer application
          aupr&egrave;s du Golf exclusivement.
        </p>
        <h3>4.2. REGLEMENT INTERIEUR</h3>
        <p>
          Le Client s&rsquo;engage &agrave; respecter sur place le r&egrave;glement int&eacute;rieur du Golf, ce dernier
          s&rsquo;engageant &agrave; le mettre &agrave; disposition du public de mani&egrave;re visible sur site. Le
          r&egrave;glement int&eacute;rieur concerne notamment les conditions d&#39;acc&egrave;s au parcours (handicap
          requis / licence FFGolf...), la tenue vestimentaire requise, le d&eacute;lai de pr&eacute;sentation avant le
          d&eacute;but du parcours, soit, selon les usages, 10 minutes &agrave; l&rsquo;avance.
        </p>
        <h3>4.3. MODIFICATION RESERVATION</h3>
        <p>
          Toute modification ou annulation doit &ecirc;tre effectu&eacute;e directement aupr&egrave;s du Golf pour les
          clients ext&eacute;rieurs. Si le prix est plus &eacute;lev&eacute;, le joueur devra payer le compl&eacute;ment
          directement aupr&egrave;s du Golf.
          <br />
          Toute annulation doit &ecirc;tre effectu&eacute;e directement aupr&egrave;s du Golf, sans remboursement
          possible.
        </p>
        <h3>4.4. ABSENCE OU RETARD</h3>
        <p>
          En cas d&rsquo;absence du Client &agrave; l&rsquo;heure r&eacute;serv&eacute;e, les sommes vers&eacute;es au
          titre de la r&eacute;servation restent acquises aux Golfs et &agrave; APS MANAGEMENT - PRIMA. Tout parcours ou
          service non consomm&eacute;, interrompu ou abr&eacute;g&eacute; du fait du Client ne saurait donner &agrave;
          un quelconque droit &agrave; remboursement.
          <br />
          En cas d&#39;arriv&eacute;e tardive, le Golf pourra, sans obligation aucune, proposer au Client un nouvel
          horaire de d&eacute;part. APS MANAGEMENT - PRIMA ne pourra, en aucun cas, &ecirc;tre tenu pour responsable de
          l&#39;impossibilit&eacute; pour le Golf de proc&eacute;der &agrave; une telle proposition.
        </p>
        <h3>4.5. INTEMPERIES</h3>
        <p>
          Le Client reconnait express&eacute;ment que les intemp&eacute;ries limitativement
          &eacute;num&eacute;r&eacute;es pourront donner lieu &agrave; compensation selon le r&egrave;glement
          int&eacute;rieur du Golf.
        </p>
        <h2>ARTICLE 5. RESPONSABILITE</h2>
        <p>
          APS MANAGEMENT - PRIMA s&rsquo;engage &agrave; mettre en &oelig;uvre tous les moyens techniques
          n&eacute;cessaires &agrave; la disponibilit&eacute; du Service et &agrave; l&rsquo;accessibilit&eacute; du
          Site. Des op&eacute;rations de maintenance pourront n&eacute;anmoins intervenir sur le site le rendant
          indisponible &agrave; la consultation par les internautes, sans que la responsabilit&eacute; de APS MANAGEMENT
          - PRIMA puisse &ecirc;tre engag&eacute;e de ce fait. D&rsquo;autres &eacute;v&egrave;nements sont susceptibles
          d&rsquo;affecter la disponibilit&eacute; du Site, comme les pannes r&eacute;seau, les d&eacute;faillances
          mat&eacute;rielles ou logicielles, ce dont APS MANAGEMENT - PRIMA ne saurait &ecirc;tre tenu pour responsable.
          <br />
          APS MANAGEMENT - PRIMA apporte le plus grand soin aux informations disponibles sur le Site et/ou concourant au
          Service, notamment dans le cadre du partenariat mis en place avec les Golfs Partenaires qui fournissent et
          mettent en ligne les informations et caract&eacute;ristiques relatives aux parcours. N&eacute;anmoins, les
          photographies, textes, graphismes et informations reproduits et illustrant le Service ne sont pas
          contractuels. En cons&eacute;quence, la responsabilit&eacute; de APS MANAGEMENT - PRIMA ne saurait &ecirc;tre
          engag&eacute;e en cas d&#39;erreur, modification ou omission quelconque de ces &eacute;l&eacute;ments.
          <br />
          APS MANAGEMENT - PRIMA ne saurait &ecirc;tre responsable des liens hypertextes accessibles via le Site si
          ceux-ci s&rsquo;av&eacute;raient contraires &agrave; la r&eacute;glementation en vigueur, APS MANAGEMENT -
          PRIMA ne saurait en effet contr&ocirc;ler l&rsquo;&eacute;volution des sites tiers vers lesquels ces liens
          pointent. APS MANAGEMENT - PRIMA supprimera promptement tout lien qui lui serait signal&eacute; pointant vers
          un contenu illicite ou portant atteinte aux droits des tiers.
          <br />
          L&#39;ex&eacute;cution du Service Payant intervient directement entre le Golf et le Client, APS MANAGEMENT -
          PRIMA intervenant uniquement au stade de la r&eacute;servation et du paiement du parcours au nom et pour le
          compte du Golf, le Golf agit en son nom et sous sa seule responsabilit&eacute; dans ses rapports avec les
          Clients lors dudit parcours ou service. Le Client reconna&icirc;t que APS MANAGEMENT - PRIMA ne pourra
          &ecirc;tre tenu pour responsable de la qualit&eacute; de prestation d&eacute;livr&eacute;e sur site, des
          dommages ou d&eacute;g&acirc;ts &eacute;ventuels qui pourraient y survenir. De m&ecirc;me, toute atteinte aux
          biens ou aux personnes sur le site du Golf rel&egrave;ve de la seule responsabilit&eacute; du Golf. Dans le
          cadre des accords existant entre APS MANAGEMENT - PRIMA et les Golfs, ces derniers se sont engag&eacute;s
          &agrave; avoir souscrit les assurances ad&eacute;quates au p&eacute;rim&egrave;tre de leur activit&eacute;.
          <br />
          La responsabilit&eacute; de APS MANAGEMENT - PRIMA au titre de son activit&eacute; de r&eacute;servation en
          temps r&eacute;el de parcours de golf exclut les dommages indirects, notamment un &eacute;ventuel
          pr&eacute;judice commercial, tous frais de transport, d&rsquo;h&eacute;bergement, ou d&rsquo;activit&eacute;
          de substitution.
          <br />
          Plus g&eacute;n&eacute;ralement, la responsabilit&eacute; de APS MANAGEMENT - PRIMA ne saurait &ecirc;tre
          engag&eacute;e que sur faute prouv&eacute;e, dans un d&eacute;lai maximum de 6 mois &agrave; compter de la
          date de parcours r&eacute;serv&eacute;.
          <br />
          Si la responsabilit&eacute; de APS MANAGEMENT - PRIMA &eacute;tait reconnue &agrave; l&rsquo;&eacute;gard du
          Client, celle-ci ne pourrait exc&eacute;der la somme r&eacute;ellement vers&eacute;e par ce dernier en vertu
          du contrat de Service Payant pour le parcours au titre duquel la responsabilit&eacute; a &eacute;t&eacute;
          engag&eacute;e.
        </p>
        <h2>ARTICLE 7 &ndash; DONNEES PERSONNELLES</h2>
        <p>
          APS MANAGEMENT - PRIMA, responsable de traitement, a d&eacute;clar&eacute; les traitements de donn&eacute;es
          effectu&eacute;es au titre du Service &agrave; la CNIL. Les donn&eacute;es b&eacute;n&eacute;ficient
          d&rsquo;un traitement conforme aux r&eacute;glementations europ&eacute;ennes et fran&ccedil;aises, quant
          &agrave; leur int&eacute;grit&eacute;, leur s&eacute;curit&eacute;, et la conformit&eacute; de leur traitement
          aux finalit&eacute;s pour lesquels elles ont &eacute;t&eacute; collect&eacute;es.
          <br />
          L&rsquo;Utilisateur b&eacute;n&eacute;ficie d&rsquo;un droit d&rsquo;acc&egrave;s, de rectification et de
          suppression de ses donn&eacute;es qu&rsquo;il peut exercer &agrave; l&rsquo;adresse &eacute;lectronique
          contact@primagolf.fr
          <br />
          Les informations personnelles relatives aux r&eacute;servations de parcours et de services sont
          &eacute;galement transmises au Golf concern&eacute; pour ex&eacute;cution du contrat, les informations
          relatives au paiement transitant exclusivement par V&eacute;rifone et ses prestataires. Le Client exercera
          &eacute;galement son droit d&rsquo;acc&egrave;s, de modification et de suppression aupr&egrave;s du Golf, en
          prenant directement contact avec ce dernier.
          <br />
          APS MANAGEMENT - PRIMA utilisera notamment l&rsquo;adresse &eacute;lectronique de ses Utilisateurs pour
          l&rsquo;envoi de sa newsletter, sauf si la case de refus de newsletter est coch&eacute;e sur le formulaire de
          commande en ligne. L&rsquo;Utilisateur peut &eacute;galement &agrave; tout moment utiliser le lien figurant en
          bas de page de la newsletter qui lui est adress&eacute;e pour se d&eacute;sinscrire.
          <br />
          En acceptant les pr&eacute;sentes CGR, l&rsquo;Utilisateur reconnait accepter l&rsquo;utilisation de cookies
          sur le Site &agrave; des fins techniques d&rsquo;optimisation du service, et &agrave; des fins statistiques et
          marketing. APS MANAGEMENT - PRIMA utilise des cookies, qui enregistrent des informations relatives &agrave; la
          navigation de l&rsquo;utilisateur sur Prima.golf, et stocke des informations que l&rsquo;utilisateur aura
          saisies durant sa visite (notamment l&rsquo;identification de la r&eacute;gion de l&rsquo;Utilisateur).
          <br />
          L&rsquo;Utilisateur accepte express&eacute;ment que ses donn&eacute;es de navigation soient collect&eacute;es
          dans le cadre de campagnes de publicit&eacute; comportementale s&rsquo;appuyant sur les secteurs
          d&rsquo;int&eacute;r&ecirc;t manifest&eacute;s lors de sa navigation sur le site ou sur d&rsquo;autres sites.
          <br />
          L&rsquo;Utilisateur peut configurer son navigateur pour accepter ou rejeter tous les cookies, ou pour
          &ecirc;tre pr&eacute;venu lorsqu&#39;un cookie est install&eacute;.
          <br />
          Pour Mozilla firefox :<br />
          Menu &quot;outil &quot; puis &quot;Options&quot; /&#39;ic&ocirc;ne &quot;vie priv&eacute;e&quot; /menu
          &quot;cookie&quot; puis s&eacute;lection de l&rsquo;option appropri&eacute;e
          <br />
          Pour Microsoft Internet Explorer :<br />
          Menu &quot;Outils&quot; / &quot;Options Internet&quot; / &#39;onglet &quot;Confidentialit&eacute;&quot;/
          s&eacute;lection du niveau souhait&eacute;
          <br />
          Pour Op&eacute;ra 6.0 et au-del&agrave; :<br />
          Menu &quot;Fichier&quot;&gt;&quot;Pr&eacute;f&eacute;rences&quot; / Vie Priv&eacute;e
          <br />
          Le Client accepte &eacute;galement la pr&eacute;sence de balises web sur certaines pages et sur la newsletter,
          dont les informations statistiques peuvent &ecirc;tre transmises aux Golfs.
        </p>
        <h2>ARTICLE 8 : PROPRIETE INTELLECTUELLE</h2>
        <p>
          APS MANAGEMENT - PRIMA d&eacute;tient tous droits ou autorisations sur le Service (notamment sur les
          logiciels, bases de donn&eacute;es) et plus g&eacute;n&eacute;ralement sur tous les &eacute;l&eacute;ments
          constitutifs du Site (nom de domaine, ergonomie, textes, marques, graphismes, logos, photographies), qui sont
          prot&eacute;g&eacute;s par les r&eacute;glementations fran&ccedil;aises et internationales relatives au droit
          de la propri&eacute;t&eacute; intellectuelle.
          <br />
          Toute autre utilisation que celle pr&eacute;vue dans le cadre du Service, notamment la reproduction, la
          modification, l&rsquo;adaptation, la distribution, copie, la transmission, la publication, la traduction ou la
          repr&eacute;sentation de ces informations ou &eacute;l&eacute;ments, ou l&rsquo;extraction quantitativement ou
          qualitativement substantielle des bases de donn&eacute;es sont interdites sans autorisation pr&eacute;alable.
          <br />
          L&rsquo;Utilisateur reconnait &eacute;galement que les contenus compris dans des publicit&eacute;s, les
          informations promotionnelles qui vous sont pr&eacute;sent&eacute;es via le Services ou par des annonceurs
          tiers sont prot&eacute;g&eacute;s par le droit d&#39;auteur, le droit des marques, ou tout autre droit reconnu
          par la l&eacute;gislation en vigueur.
        </p>
        <h2>ARTICLE 9 : DISPOSITIONS GENERALES</h2>
        <p>
          <b>9.1. Non validit&eacute; partielle :</b> Si l&rsquo;une quelconque des dispositions des CGR &eacute;tait
          d&eacute;clar&eacute;e nulle ou sans objet au regard d&rsquo;une disposition l&eacute;gislative ou
          r&eacute;glementaire en vigueur, et/ou d&rsquo;une d&eacute;cision de justice ayant autorit&eacute; de chose
          jug&eacute;e, elle serait r&eacute;put&eacute;e non &eacute;crite et n&rsquo;entra&icirc;nerait pas la
          nullit&eacute; des autres dispositions.
          <br />
          <b>9.2. Force majeure :</b> APS MANAGEMENT - PRIMA et le Golf sont lib&eacute;r&eacute;s de leurs obligations
          respectives en cas de force majeure. La force majeure se d&eacute;finit comme tout &eacute;v&egrave;nement
          ext&eacute;rieur aux parties, impr&eacute;visible et insurmontable, notamment en cas de gr&egrave;ve,
          insurrection ou &eacute;meute.
          <br />
          <b>9.3. Cession du contrat :</b> APS MANAGEMENT - PRIMA pourra &agrave; tout moment c&eacute;der les droits et
          obligations n&eacute;es des pr&eacute;sentes CGR.
          <br />
          <b>9.4. Loi applicable :</b> Les CGR et le contrat sont soumis au droit fran&ccedil;ais.
        </p>
      </div>
    );
  }
}

export default TermsAndConditions;
